import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type FlowModel from 'garaje/models/flow';

type DataCategory = 'Photos and media' | 'Legal documents' | 'Search text';
class FieldSetting extends Model {
  /**
   * sign in field id sent up
   */
  @attr('number') declare signInFieldId: number | null;

  /**
   * alternative send up field id or data category
   */
  @attr('string') declare dataCategory: DataCategory | null;
  /**
   * sign in field name
   */
  @attr('string') declare displayName: string;
  @attr('boolean') declare isSelected: boolean;

  @belongsTo('flow', { async: true, inverse: null }) declare flow: AsyncBelongsTo<FlowModel>;
}

export default FieldSetting;

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'field-setting': FieldSetting;
  }
}
